import session from '@/shared/session'

const initialState = () => ({
	entries: [],
})

const state = initialState()

const getters = {
	getPartusboekEntries: (state) => () => {
		return state.entries
	},
}

const actions = {
	resetState({ commit }) {
		commit('reset_state')
	},

	fetchPartusboekEntries({ commit, dispatch }) {
		dispatch("loading/load", "partusboek", { root: true })
		return session
				.get(`/api/partusboek/`, { params: { per_page: 100 } })
				.then(res => {
					commit("set_entries", res.data.results || res.data)
					return state.entries
				})
	      .finally(() => {
	        dispatch("loading/end", "partusboek", { root: true })
	      })
	},

	createPartusboekEntry({ dispatch }, data) {
		dispatch("loading/load", "partusboek", { root: true })
		return session
				.post(`/api/partusboek/`, data)
				.then(() => dispatch("fetchPartusboekEntries"))
	      .finally(() => {
	        dispatch("loading/end", "partusboek", { root: true })
	      })
	},

	updatePartusboekEntry({ dispatch }, { id, data }) {
		dispatch("loading/load", "partusboek", { root: true })
		return session
				.patch(`/api/partusboek/${id}/`, data)
				.then(() => dispatch("fetchPartusboekEntries"))
      .finally(() => {
        dispatch("loading/end", "partusboek", { root: true })
      })
	},

	deletePartusboekEntry({ dispatch }, id) {
		dispatch("loading/load", "partusboek", { root: true })
		return session
				.delete(`/api/partusboek/${id}/`)
				.then(() => dispatch("fetchPartusboekEntries"))
      .finally(() => {
        dispatch("loading/end", "partusboek", { root: true })
      })
	},

	exportPartusboekCsv({ dispatch }) {
		return session
				.get(`/api/partusboek/export_csv/`, { responseType: 'blob' })
				.then(res => {
					const url = window.URL.createObjectURL(new Blob([res.data]))
					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'partusboek.csv')
					document.body.appendChild(link)
					link.click()
					link.remove()
					window.URL.revokeObjectURL(url)
				})
	},
}

const mutations = {
	reset_state(state) {
		Object.assign(state, initialState())
	},
	set_entries(state, entries) {
		state.entries = entries
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
